import { render, staticRenderFns } from "./communicationPreferences.vue?vue&type=template&id=bbfe721c&scoped=true"
import script from "./communicationPreferences.vue?vue&type=script&lang=ts"
export * from "./communicationPreferences.vue?vue&type=script&lang=ts"
import style0 from "./communicationPreferences.vue?vue&type=style&index=0&id=bbfe721c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfe721c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VCheckbox,VRadio,VRadioGroup})
